"use strict";
"use client";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paragraphHasOnlyBlockSwapIn = paragraphHasOnlyBlockSwapIn;
exports.sharedMarkdownComponents = void 0;
var _react = _interopRequireDefault(require("react"));
var _codeSnippet = require("@design/components/shadcncraft/pro-application/code-snippet-2");
var _Mermaid = _interopRequireDefault(require("./Mermaid"));
var _chatMarkers = require("./chatMarkers");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function extractCodeText(children) {
  return children.filter(function (c) {
    return c.type === "text";
  }).map(function (c) {
    var _c$value;
    return (_c$value = c.value) !== null && _c$value !== void 0 ? _c$value : "";
  }).join("");
}
function codeBlockOf(node) {
  var _hast$children, _onlyChild$children;
  var hast = node;
  var onlyChild = (hast === null || hast === void 0 || (_hast$children = hast.children) === null || _hast$children === void 0 ? void 0 : _hast$children.length) === 1 ? hast.children[0] : undefined;
  if (!onlyChild || onlyChild.type !== "element" || onlyChild.tagName !== "code") return null;
  if (!((_onlyChild$children = onlyChild.children) !== null && _onlyChild$children !== void 0 ? _onlyChild$children : []).every(function (child) {
    return child.type === "text";
  })) return null;
  return onlyChild;
}
var CODE_BLOCK_CLASSES = "p-3 rounded-xl my-2 overflow-x-auto";
var CODE_BLOCK_WITH_LANGUAGE_CLASSES = "".concat(CODE_BLOCK_CLASSES, " bg-gray-900 text-gray-100");
var CODE_BLOCK_PLAIN_CLASSES = "".concat(CODE_BLOCK_CLASSES, " bg-background-subtle text-foreground-primary");
var CODE_BLOCK_COPY_BUTTON_CLASSES = "absolute top-2 right-2 text-gray-400 hover:text-gray-900";
var INLINE_CODE_CLASSES = "bg-background-subtle px-1 py-0.5 rounded-md text-xs font-mono";
function paragraphHasOnlyBlockSwapIn(node) {
  var _child$properties;
  var hast = node;
  var children = hast === null || hast === void 0 ? void 0 : hast.children;
  if (!children || children.length !== 1) return false;
  var child = children[0];
  if (child.type !== "element" || child.tagName !== "a") return false;
  var href = (_child$properties = child.properties) === null || _child$properties === void 0 ? void 0 : _child$properties.href;
  return typeof href === "string" && (0, _chatMarkers.isBlockChatMarkerHref)(href);
}
var sharedMarkdownComponents = exports.sharedMarkdownComponents = {
  p: function p(_ref) {
    var children = _ref.children,
      node = _ref.node;
    if (paragraphHasOnlyBlockSwapIn(node)) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: children
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "my-1",
      children: children
    });
  },
  ul: function ul(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
      className: "list-disc pl-6 my-2 space-y-1",
      children: children
    });
  },
  ol: function ol(_ref3) {
    var children = _ref3.children,
      start = _ref3.start;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("ol", {
      className: "list-decimal pl-6 my-2 space-y-1",
      start: start,
      children: children
    });
  },
  li: function li(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
      className: "pl-1",
      children: children
    });
  },
  blockquote: function blockquote(_ref5) {
    var children = _ref5.children;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("blockquote", {
      className: "my-4 border-l-4 border-border-default bg-background-subtle px-4 py-2",
      children: children
    });
  },
  table: function table(_ref6) {
    var children = _ref6.children;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "overflow-x-auto subtle-scrollbar my-4",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("table", {
        className: "border-collapse w-full text-sm rounded-lg overflow-hidden border border-border-default",
        children: children
      })
    });
  },
  th: function th(_ref7) {
    var children = _ref7.children,
      style = _ref7.style;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("th", {
      className: "border border-border-default px-3 py-2 text-left bg-background-subtle font-semibold",
      style: style,
      children: children
    });
  },
  td: function td(_ref8) {
    var children = _ref8.children,
      style = _ref8.style;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("td", {
      className: "border border-border-default px-3 py-2 text-left",
      style: style,
      children: children
    });
  },
  code: function code(_ref9) {
    var children = _ref9.children;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("code", {
      className: INLINE_CODE_CLASSES,
      children: children
    });
  },
  pre: function pre(_ref0) {
    var _codeBlock$properties, _codeBlock$properties2, _codeBlock$children;
    var children = _ref0.children,
      node = _ref0.node;
    var codeBlock = codeBlockOf(node);
    if (!codeBlock) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("pre", {
        className: CODE_BLOCK_PLAIN_CLASSES,
        children: children
      });
    }
    var classes = (_codeBlock$properties = (_codeBlock$properties2 = codeBlock.properties) === null || _codeBlock$properties2 === void 0 ? void 0 : _codeBlock$properties2.className) !== null && _codeBlock$properties !== void 0 ? _codeBlock$properties : [];
    var codeText = extractCodeText((_codeBlock$children = codeBlock.children) !== null && _codeBlock$children !== void 0 ? _codeBlock$children : []);
    if (classes.includes("language-mermaid")) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Mermaid.default, {
        chart: codeText
      });
    }
    var hasLanguage = classes.some(function (c) {
      return c.startsWith("language-");
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "relative",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("pre", {
        className: hasLanguage ? CODE_BLOCK_WITH_LANGUAGE_CLASSES : CODE_BLOCK_PLAIN_CLASSES,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("code", {
          className: classes.join(" ") || undefined,
          children: codeText
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_codeSnippet.CodeSnippet2Copy, {
        value: codeText,
        className: CODE_BLOCK_COPY_BUTTON_CLASSES
      })]
    });
  },
  h1: function h1(_ref1) {
    var children = _ref1.children;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
      className: "text-2xl font-semibold my-4",
      children: children
    });
  },
  h2: function h2(_ref10) {
    var children = _ref10.children;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
      className: "text-xl font-semibold my-3",
      children: children
    });
  },
  h3: function h3(_ref11) {
    var children = _ref11.children;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
      className: "text-lg font-semibold my-2",
      children: children
    });
  },
  h4: function h4(_ref12) {
    var children = _ref12.children;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("h4", {
      className: "text-base font-semibold my-2",
      children: children
    });
  }
};